import React from 'react';
import MultiSelect from '../../../../../ui/select/MultiSelect';
import Checkbox from '../../../../../ui/checkbox/Checkbox';
import Button, { ButtonIconPosition, ButtonThemes } from '../../../../../ui/button/Button';
import { Icon } from '../../../../../ui/icon/Icon';
import { Icons } from '../../../../../ui/icon/icons/material';
import { IconTheme } from '../../../../../ui/icon/Icon.types';
import { CustomSelectOptionBaseType } from '@danfoss/mosaic-core';
import styles from './PromptFilters.module.scss';

type Option = { value: string; label: string; };

type MultiSelectValue = string | string[] | Option | Option[] | CustomSelectOptionBaseType | CustomSelectOptionBaseType[];

interface PromptGalleryFilterProps {
    labels: {
        filterAssistant: string;
        filterCategory: string;
        filterCreatedByMe: string;
        promptManagementTitle: string;
    };
    allowedPersonaOptions: Option[];
    selectedAssistantPrompts: string[];
    selectedCategories: string[];
    categoryOptions: Option[];
    isChecked: boolean;
    setIsChecked: (v: boolean) => void;
    handleResetFilter: () => void;
    onPromptManagementNavigate: () => void;
    handleAssistantChange: (option?: MultiSelectValue) => void;
    handleCategoryChange: (option?: MultiSelectValue) => void;
}

const PromptFilters: React.FC<PromptGalleryFilterProps> = ({
    labels,
    allowedPersonaOptions,
    selectedAssistantPrompts,
    selectedCategories,
    categoryOptions,
    isChecked,
    setIsChecked,
    handleResetFilter,
    onPromptManagementNavigate,
    handleAssistantChange,
    handleCategoryChange,
}) => (
    <div className={styles.controlsRow}>
        <MultiSelect
            className={styles.select}
            placeholder={labels.filterAssistant}
            value={selectedAssistantPrompts}
            isSearchable={true}
            options={allowedPersonaOptions.map(({ value, label }) => ({
                value,
                label,
            }))}
            onChange={handleAssistantChange}
        />
        <MultiSelect
            className={styles.select}
            placeholder={labels.filterCategory}
            value={selectedCategories}
            isSearchable={true}
            options={categoryOptions}
            onChange={handleCategoryChange}
        />
        <Checkbox
            label={labels.filterCreatedByMe}
            isChecked={isChecked}
            onChange={setIsChecked}
        />
        <Button
            iconPosition={ButtonIconPosition.beginning}
            theme={ButtonThemes.textSecondary}
            onClick={handleResetFilter}
            icon={
                <Icon.Base
                    size={22}
                    title=""
                    isClickable
                    theme={IconTheme.inherit}
                    iconName={Icons.filterReset}
                />
            }
        />
        <Button label={labels.promptManagementTitle} theme={ButtonThemes.textPrimary} className={styles.rightButton} onClick={onPromptManagementNavigate} />
    </div>
);

export default PromptFilters;
